var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$page.props.errors && _vm.show)?_c('div',{staticClass:"alert alert-danger",class:{show: _vm.show}},_vm._l((_vm.$page.props.errors),function(error){return _c('ul',{key:error.id},[_c('li',[_vm._v(" "+_vm._s(error))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }